// Copyright (c) 2019 Sagacity Solutions Inc. All right reserved.
'use strict';

import api from '../api';

export default {
  namespaced: true,
  state: {
    events: [],
    hashid: '',
    cardid: '',
    scheduleid: '',
    status: 0,
    reporturl: '',
    videourls: [],
    expire: new Date(),
    showReward: false,
  },
  getters: {
    eventCount: state => state.events.length,
  },
  mutations: {
    setState(state, data) {
      state.cardid = data.CardID;
      state.hashid = data.HashID;
      state.events = data.Events;
      state.scheduleid = data.ScheduleID;
      state.videourls = data.VideoURLs;
      state.status = data.Report.Status || 0;
      state.hash = data.Report.Hash;
      state.expire = new Date(data.Report.Expire);
      state.showReward = data.Report.ShowReward;
    },
  },
  actions: {
    getEvents: async function({commit}, tagid) {
      try {
        let data = await api.getEventForTagID(tagid);
        commit('setState', data);
        commit('language/setLanguage', data.Language, { root: true});
      } catch(err) {
        alert(err);
      }
    },
    confirmDoseIntake: async function({commit}, dose) {
      try {
        let data = await api.confirmDoseIntake(dose);
        commit('setState', data);
      } catch(err) {
        alert(err);
      }
    }
  }
}
